var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as i0 from "@angular/core";
var NumberService = /** @class */ (function () {
    function NumberService() {
    }
    /**
     * For the given instance of type <T>, return a new instance of type <T> with rounded number fields.
     * @param source The source model.
     * @param precision The number of significant digits.
     */
    NumberService.prototype.roundModel = function (source, precision) {
        var _this = this;
        var roundedTarget = __assign({}, source);
        // round number fields
        Object.keys(source)
            .filter(function (field) { return typeof (source[field]) === 'number'; })
            .forEach(function (field) {
            roundedTarget[field] = _this.roundNumber(source[field], precision);
        });
        // instance of <T> with rounded fields
        return roundedTarget;
    };
    /**
     * Round the the specified source number to specific precision.
     * @param source The number to round.
     * @param precision The number of significant digits.
     */
    NumberService.prototype.roundNumber = function (source, precision) {
        return Math.round(source * Math.pow(10, precision)) / Math.pow(10, precision);
    };
    NumberService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NumberService_Factory() { return new NumberService(); }, token: NumberService, providedIn: "root" });
    return NumberService;
}());
export { NumberService };
